/**
 * Formata um identificador com base na quantidade de dígitos numéricos.
 *
 * - Se o identificador tiver 11 dígitos numéricos, assume que é um telefone e formata como (XX) XXXXX-XXXX.
 * - Se tiver 16 dígitos numéricos, assume que é uma tag e formata como XXXX XXXX XXXX XXXX.
 * - Caso contrário, retorna o valor original.
 *
 * @param {string} value - Identificador que pode representar um número de telefone ou uma tag.
 * @returns {string} Identificador formatado de acordo com a quantidade de dígitos.
 */
export const formatPhoneAndSerialNumberMask = (value: string): string => {
  const onlyNumbers = value.replace(/\D/g, "");

  switch (true) {
    case onlyNumbers.length === 11:
      return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 7)}-${onlyNumbers.slice(7)}`;

    case onlyNumbers.length === 16:
      return onlyNumbers.replace(/(\d{4})(?=\d)/g, "$1 ").trim();

    default:
      return value;
  }
};
